import MessageLayout from '../MessageLayout'
import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'
export default {
  components: { MessageLayout },
  mixins: [MixinPaletteFidmarques],
  props: {
    isArchived: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    nl2br (text) {
      return text.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    interpreteSchemeUrl (scheme) {
      const schemeParts = scheme.split('://')
      const path = schemeParts[1]
      const pathParts = path.split('/')

      switch (pathParts[0]) {
        case 'receipt':
          this.actionOnReceipt(scheme, pathParts)
          break
        default:
          this.$airbrake.notifyFromComponent(
            new Error(`unknown scheme part "${pathParts[0]}"`),
            { scheme },
            { vm: this },
          )
      }
    },
    actionOnReceipt (scheme, pathParts) {
      const receiptUuid = pathParts[1]
      switch (pathParts[2]) {
        case 'skip_validation':
          this.$PE.client.skipReceiptValidation({ receiptUuid })
            .then(
              () => { this.$store.dispatch('timeline/reset') },
              (error) => {
                this.$airbrake.notifyFromKit(error, { locator: 'skipReceiptValidation' }, { store: this.$store })
                this.addToastGenericError()
              }
            )
          break
        case 'review':
          this.$router.push(`/profile/receipts/${receiptUuid}/review`)
          break
        default:
          this.$airbrake.notifyFromComponent(
            new Error(`unknown receipt scheme part "${pathParts[2]}"`),
            { scheme },
            { vm: this },
          )
      }
    },
  },
}
